import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import { SansText } from '../SansText/SansText'
import { Image, Link } from './CtaWithBackground.styles'
import type { CtaWithBackgroundProps } from './CtaWithBackground.types'

export const CtaWithBackground = ({
  text,
  image,
  url,
}: CtaWithBackgroundProps): JSX.Element => {
  return (
    <Link href={url}>
      <Image
        lazyload
        lqip
        imgSrc={setQueryParams(image.src, [{ name: 'width', value: '30' }])}
        alt={image.alt || text}
        draggable={false}
        transitionDuration={50}
        sources={buildIntrinsicWidthSources({
          src: image.src,
          maxWidth: image.width,
        })}
      />
      <SansText uppercase underline fontWeight="500">
        {text}
      </SansText>
    </Link>
  )
}
